import React from "react";
import { useHistory } from "react-router-dom";
import { BulletPoint, SlideCarousel } from "./components";
import "react-responsive-carousel/lib/styles/carousel.css"; // requires a loader

import optionsIntegrations from "../../../../../assets/images/integration/optionsIntegrations.png";

import blingV3_1 from "../../../../../assets/images/blingV3/BlingV3_01.png";
import blingV3_2 from "../../../../../assets/images/blingV3/BlingV3_02.png";
import blingV3_3 from "../../../../../assets/images/blingV3/BlingV3_03.png";
import blingV3_4 from "../../../../../assets/images/blingV3/BlingV3_04.png";
import blingV3_5 from "../../../../../assets/images/blingV3/BlingV3_05.png";


import blingV3_6 from "../../../../../assets/images/blingV3/blingV3_6.png";
import blingV3_7 from "../../../../../assets/images/blingV3/blingV3_7.png";
import blingV3_8 from "../../../../../assets/images/blingV3/blingV3_8.png";
import blingV3_9 from "../../../../../assets/images/blingV3/blingV3_9.png";
import blingV3_10 from "../../../../../assets/images/blingV3/blingV3_10.png";
import blingV3_11 from "../../../../../assets/images/blingV3/blingV3_11.png";
import blingV3_12 from "../../../../../assets/images/blingV3/blingV3_12.png";
import blingV3_13 from "../../../../../assets/images/blingV3/blingV3_13.png";
import blingV3_14 from "../../../../../assets/images/blingV3/blingV3_14.png";
import blingV3_15 from "../../../../../assets/images/blingV3/blingV3_15.png";
import blingV3_16 from "../../../../../assets/images/blingV3/blingV3_16.png";
import blingV3_17 from "../../../../../assets/images/blingV3/blingV3_17.png";
import blingV3_18 from "../../../../../assets/images/blingV3/blingV3_18.png";
import blingV3_19 from "../../../../../assets/images/blingV3/blingV3_19.png";

import brcomerceLogo from "../../../../../assets/logo/logo_brcomerce_250x250.svg";

import activeOrderCreation from "../../../../../assets/images/active-order-create.png";
import disableSecureOption from "../../../../../assets/images/disable-secure-option.png";
import styles from "./styles.module.scss";
import store from "../../../../../store/store";

const TutorialBlingV3 = () => {
  const carousel1 = [
    {
      image: blingV3_1
    },
    {
      image: blingV3_2
    },
    {
      image: blingV3_3
    },
  ];

  const carousel2 = [
    {
      image: blingV3_6
    },
    {
      image: blingV3_7
    }
  ];

  const carousel3 = [
    {
      image: blingV3_8
    },
    {
      image: blingV3_9
    },
    {
      image: blingV3_4
    },
  ];

  const carousel4 = [
    {
      image: blingV3_10
    },
    {
      image: optionsIntegrations
    },
    {
      image: blingV3_5
    },
    {
      image: blingV3_11
    },
    {
      image: blingV3_12
    },
    {
      image: blingV3_13
    },
  ];

  const carousel5 = [
    {
      image: blingV3_15
    },
    {
      image: blingV3_16
    },
    {
      image: blingV3_17
    }
  ]
    ;

  const history = useHistory();

  const { auth } = store.getState();
  const { user } = auth;
  const baseUrl = String(process.env.REACT_APP_API_HOST);
  const webhookUrl = `${baseUrl}/blingV3/orders/all/webhook?storeId=${user.sub}`

  const [copied, setCopied] = React.useState(false);

  const handleCopyClick = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 5000);
    }).catch(err => {
      console.error('Erro ao copiar: ', err);
    });
  };


  return (
    <main className={styles.container}>
      <div className={styles.content}>
        <header className={styles.contentHeader}>
          <p>Como fazer a integração?</p>
        </header>
        <div className={styles.contentBody}>
          <section className={styles.contentSection}>
            <h4>Passo a passo para conectar sua plataforma Bling V3 à BRCom</h4>

            <BulletPoint order="1">
              <p>
                O primeiro passo é cadastrar um aplicativo na <b>Bling</b>.
                <br></br>
                Para isso acesse seu painel admin da <b>Bling</b>, no canto superior direito, em <b>Central de extensões {">"} Área do integrador {">"} Criar novo aplicativo</b>.
              </p>
            </BulletPoint>

            <SlideCarousel steps={carousel1} />

            <BulletPoint order="2">
              <p>
                Crie um novo aplicativo usando as seguintes informações:
              </p>
            </BulletPoint>

            <SlideCarousel steps={carousel2} />

            <p>
              Logo: <a
                download="brcomerce-logo.svg"
                href={brcomerceLogo}
                title="Logo BRComerce"
              >
                Baixar logo BRComerce
              </a>
              <br></br>
              Nome: <b>BRComerce</b>
              <br></br>
              Categoria: <b>{`Gestão de Entregas > Transportadora`}</b>
              <br></br>
              Descrição: <b>Aplicativo para integrar a BRComerce a Bling</b>
              <br></br>
              URL de redirecionamento: <b>https://app.brcomerce.com.br/callback/blingV3</b>
            </p>

            <BulletPoint order="3">
              <p>
                Na Lista de escopos, adicione <b>TODAS as opções</b> e salve o aplicativo.
              </p>
            </BulletPoint>

            <SlideCarousel steps={carousel3} />


            <BulletPoint order="4">
              <p>
                Agora que temos o <b>Client ID</b> e <b>Client Secret</b>, acesse a integração Bling V3 e autentique o usuário.
              </p>
            </BulletPoint>

            <SlideCarousel steps={carousel4} />

            <BulletPoint order="5">
              <p>
                Preencha os campos de endereço.
              </p>
            </BulletPoint>

            <div className={`${styles.imgs} `}>
              <img
                src={blingV3_14}
                alt="Tutorial Bling 14"
                className={styles.cardImage}
              />
            </div>

            <BulletPoint order="6">
              <p>
                Configure o status em que o pedido deve estar para ser importado e alterado em determinados eventos.
                <br></br>
                A opção de desativar a alteração de status é aconselhada apenas com o uso do Webhook para criação de pedidos.
              </p>
            </BulletPoint>

            <div className={styles.imgs}>
              <img
                src={blingV3_19}
                alt="Tutorial Bling 19"
                className={styles.cardImage}
              />
            </div>


            <BulletPoint order="7">
              <p>
                <b>NOVO</b>: Agora é possível que os pedidos sejam criados através do Webhook:
                <br></br>
                <a href="https://www.bling.com.br/b/cadastro.aplicativos.php#/list" target="_blank">Ir para Cadastro de aplicativos</a>
                <br></br>
                URL única para o seu usuário: {copied ?
                  <b style={{ color: "#409E6A", cursor: "pointer" }} onClick={() => handleCopyClick(webhookUrl)}>Copiado</b>
                  : <b style={{ color: "#409E6A", cursor: "pointer" }} onClick={() => handleCopyClick(webhookUrl)}>Clique aqui para copiar</b>
                }
              </p>
            </BulletPoint>

            <SlideCarousel steps={carousel5} />

            <p>
              O tipo de evento pode ser configurado segundo a imagem abaixo:
            </p>

            <div className={styles.imgs}>
              <img
                src={blingV3_18}
                alt="Tutorial Bling 18"
                className={styles.cardImage}
              />
            </div>


            <BulletPoint order="8">
              <p>
                Caso queira desativar a criação de pedido nessa integração, vire a chave para "Desativado"
                <br></br>
                As demais funcionalidades relacionadas a essa integração continuarão ativas.
              </p>
            </BulletPoint>

            <div className={styles.imgs}>
              <img
                src={activeOrderCreation}
                alt="activeOrderCreation"
                className={styles.cardImage}
              />
            </div>

            <BulletPoint order="9">
              <p>
                É possível, também, <b>desativar a cotação de frete com Seguro</b> marcando a chave de Configuração de Seguro como ativado.
                <br></br>
                Essa configuração será aplicada em <b>todos</b> os tipos de fretes que são cotados.
                <br></br>
                Após configurar tudo, clique em salvar.
              </p>
            </BulletPoint>

            <div className={styles.imgs}>
              <img
                src={disableSecureOption}
                alt="disableSecureOption"
                className={styles.cardImage}
              />
            </div>

            <button
              onClick={() => history.push("/integracoes")}
              className={`${styles.button} ${styles.btnBack}`}
            >
              Voltar
            </button>
          </section>
        </div>
      </div>
    </main >
  );
};

export { TutorialBlingV3 };
